//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: 'bottom'
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        close(eve) {
            this.$emit('input', false);
        }
    }
};
